export enum LicenseCostResponsibility {
  LICENSE_PROVIDED_BY_ORGANIZATION = `License provided at no cost to the user (requestor's organization)`,
  LICENSE_PAID_BY_ORGANIZATION = `License required, paid by requestor's organization`,
  PRODUCT_PLATFORM_TEAM_COVERED = `Covered by Product/Platform Team (No Chargeback)`,
  CHARGED_TO_REQUESTOR_ORGANIZATION = `Charged to Requestor's Organization (Chargeback)`,
  NOT_APPLICABLE = 'Not Applicable',
}
